import React, { useEffect } from "react";
import { email, socialMedia, resumeUrl } from "../../config/constants";
import { getSr } from "../../utils/sr";
import { usePrefersReducedMotion } from "../../hooks";
import { srConfig } from "../../config";
import { StyledContactSection } from "./Contact.styles";

const Contact = () => {
  const prefersReducedMotion = usePrefersReducedMotion();
  const linkedIn = socialMedia.find((item) =>
    item.name.toLowerCase().includes("linkedin"),
  );

  useEffect(() => {
    if (prefersReducedMotion) return;

    const reveal = async () => {
      const sr = await getSr();
      sr.reveal("#contact", srConfig());
    };

    if ("requestIdleCallback" in window) {
      requestIdleCallback(reveal);
    } else {
      setTimeout(reveal, 200);
    }
  }, [prefersReducedMotion]);

  return (
    <StyledContactSection id="contact">
      <div className="container">
        <h2 className="title">Let’s Connect</h2>

        <p>
          I’m currently looking for mid-level Software Engineer roles in the New
          York City area, with a strong interest in hybrid and remote
          opportunities. If you have a role, collaboration, or just want to
          connect, feel free to reach out. I’d love to hear from you!
        </p>

        <a className="email-link" href={`mailto:${email}`}>
          Get in Touch
        </a>

        <div className="contact-links">
          <a href={resumeUrl} target="_blank" rel="noopener noreferrer">
            View Resume
          </a>
          {linkedIn && (
            <a href={linkedIn.url} target="_blank" rel="noopener noreferrer">
              Connect on LinkedIn
            </a>
          )}
        </div>
      </div>
    </StyledContactSection>
  );
};

export default Contact;
